import { BaseService } from "./common/base";
import type { Transmission } from "../../../../api/src/transmissions/entities/transmission.entity";
import type { FindTransmissionDTO } from "../../../../api/src/transmissions/dto/find-transmissions.dto";

export class TransmissionService extends BaseService<
  Transmission,
  FindTransmissionDTO
> {
  constructor() {
    super("transmissions");
  }

  createComment(id, data) {
    return this.api.post(`${id}/comment`, data).then((res) => res.data);
  }
}
